import React from "react";

import { Chip } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export const WSCInputCompletionChip = ({ completed }: { completed: boolean }) => {
    if (completed)
        return <Chip label='Completed' color='success' icon={<CheckCircleIcon />} />
    else
        return <Chip label='Incomplete' color='error' icon={<CancelIcon />} />
}